<template lang="html">

  <section class="carousel">
    <div class="row">      
      <div class="col-md-6 grid-margin" style="margin: auto;">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title"> <b-button variant="primary"  @click="superScope()"><i class="mdi mdi-close"></i>close</b-button></h4>
            <b-carousel id="carousel2" controls indicators background="#ababab" :interval="3000" >
              <template v-if="images && images.length">
                  <b-carousel-slide v-for="(img,index) in images" :id="'image_'+index">
                    {{testImg(img,index)}}
                    <img onerror="javascript:alert('err')" slot="img" :src="img.src" alt="slide image">
                    <h3>{{img.name}}</h3>
                    <p>{{img.src}}</p>
                  </b-carousel-slide>
              </template>
            </b-carousel>
          </div>
        </div>
      </div>   
    </div>
  </section>

</template>

<script lang="js">
export default {
  name: 'carousel',
  props:['images','superScope'],
  methods:{
    testImg:(elem,index)=>{
      var w = ( document.querySelector('#image_'+index+' img') &&  document.querySelector('#image_'+index+' img').width) ? document.querySelector('#image_'+index+' img').width : null;
      if(!w || w <= 1){
        // console.log(document.querySelector('#image_'+index+''))
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .carousel .carousel-inner .carousel-item img {
      max-width: 100%;
      width: 100vw;
  }
</style>
